import { Stack } from '@mui/material';

import { ModulFromThemaRouter, PlanungsinformationFromThemaRouter, StrukturellesFormat } from '../../../dtos';
import { isOnlineAndOrPraesenz, onlineAndOrPraesenz as onlineAndOrPraesenzEnum } from '../../../utils/isOnline';
import { sitzordnungLabelByValue } from '../content';
import { LabelValue } from '../LabelValue';
import { RaumgroesseWithTooltip } from './RaumgroesseWithTooltip';
import { content } from './TerminPlanungsinformationenCard.content';

type SecondSectionProps = {
  planungsinformation: PlanungsinformationFromThemaRouter;
  isOnline: boolean;
  strukturellesFormat: StrukturellesFormat;
  module: ModulFromThemaRouter[];
};

export const SecondSection = ({ planungsinformation, isOnline, strukturellesFormat, module }: SecondSectionProps) => {
  const { sitzordnung, raumgroesse, teilnehmerErwartet, locationBesonderheiten, gruppenraumNotwendig, onlineTool } =
    planungsinformation;

  const onlineAndOrPraesenz = isOnlineAndOrPraesenz(isOnline, strukturellesFormat, module);

  return (
    <Stack spacing={1.5}>
      {(onlineAndOrPraesenz === onlineAndOrPraesenzEnum.PRAESENZ ||
        onlineAndOrPraesenz === onlineAndOrPraesenzEnum.PRAESENZ_AND_ONLINE) && (
        <>
          <LabelValue
            label={content.fields.raumgroesse}
            value={<RaumgroesseWithTooltip value={raumgroesse?.toString()} />}
          />
          <LabelValue
            label={content.fields.bestuhlungsart}
            value={sitzordnung && sitzordnungLabelByValue[sitzordnung]}
          />
        </>
      )}
      <LabelValue label={content.fields.teilnehmer} value={teilnehmerErwartet?.toString()} />
      {locationBesonderheiten.length > 0 && (
        <LabelValue
          label={content.fields.locationBesonderheiten}
          value={printLocationBesonderheiten(locationBesonderheiten)}
        />
      )}
      {gruppenraumNotwendig && (
        <LabelValue label={content.fields.gruppenraum} value={printGruppenraum(gruppenraumNotwendig)} />
      )}
      {(onlineAndOrPraesenz === onlineAndOrPraesenzEnum.ONLINE ||
        onlineAndOrPraesenz === onlineAndOrPraesenzEnum.PRAESENZ_AND_ONLINE) && (
        <LabelValue label={content.fields.tool} value={onlineTool ? content.tools[onlineTool] : '-'} />
      )}
    </Stack>
  );
};

const printLocationBesonderheiten = (
  locationBesonderheiten: PlanungsinformationFromThemaRouter['locationBesonderheiten'],
): string =>
  locationBesonderheiten //
    .map((besonderheit) => content.locationBesonderheiten[besonderheit])
    .join(', ');

const printGruppenraum = (gruppenraumNotwendig: number[] | null): string | undefined =>
  gruppenraumNotwendig //
    ?.map((day) => `${content.units.tag} ${day}`)
    .join(', ');
